// @flow strict

import { string, object, type Schema, boolean } from 'yup';
import { type FormValue, type FormValueWithUpflowy } from './types';

export const validationSchema: Schema<FormValue, any> = object().shape({
  firstName: string()
    .trim()
    .required('First name is required'),
  lastName: string()
    .trim()
    .required('Last name is required'),
  companyName: string(),
  phoneNumber: string()
    .trim()
    .required('Phone number is required'),
  jobTitleGroup: string()
    .trim()
    .required('Specialty is required'),
  jobTitleId: string().required('Title is required'),
  jobTitleOther: string()
    .trim()
    .when('jobTitleId', {
      is: 0,
      then: string().required('Job title is required'),
      otherwise: string().nullable(),
    }),
  jobTitleGroupOther: string()
    .trim()
    .when('jobTitleId', {
      is: 0,
      then: string().required('Profession is required'),
      otherwise: string().nullable(),
    }),
  locationId: string().required('City is required'),
  isSso: boolean().required(),
  password: string().when(['isSso', 'signUpCompleted'], {
    is: false,
    then: string().required('Password is required'),
    otherwise: string().required('Password is required'),
  }),
});

export const validationSchemaWithUpflowy: Schema<FormValueWithUpflowy, any> = object().shape({
  firstName: string()
    .trim()
    .required('First name is required'),
  lastName: string()
    .trim()
    .required('Last name is required'),
  companyName: string(),
  phoneNumber: string()
    .trim()
    .required('Phone number is required'),
  locationId: string().required('City is required'),
  isSso: boolean().required(),
  password: string().when(['isSso', 'signUpCompleted'], {
    is: false,
    then: string().required('Password is required'),
    otherwise: string().required('Password is required'),
  }),
});

export const passwordOnlyValidationSchema: Schema<FormValue, any> = object().shape({
  firstName: string(),
  lastName: string(),
  companyName: string(),
  phoneNumber: string(),
  jobTitleGroup: string(),
  jobTitleId: string(),
  jobTitleOther: string(),
  jobTitleGroupOther: string(),
  locationId: string(),
  isSso: boolean(),
  password: string()
    .trim()
    .required('Password is required'),
});
